import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FilterPipe } from '../../pipes/filter.pipe';
import { NavigationUtils } from 'src/app/navigation-utils';
import { IframeService } from 'src/app/services/iframe.service';
import { MenuService } from 'src/app/services/menu-service.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { UserNavigationService } from 'src/app/services/user-navigation.service';

import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';
import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
@Component({
    standalone: true,
    selector: 'app-menu-extension',
    templateUrl: './menu-extension.component.html',
    styleUrls: ['./menu-extension.component.scss'],
    imports: [
        CommonModule,
        FilterPipe,
        FormsModule,
        NgxPaginationModule
    ]
})

export class MenuExtensionComponent implements OnInit, OnDestroy {
    @Output() menuExtensionClicked: EventEmitter<MenuItem> = new EventEmitter();
    @ViewChild('pagination') pagin: ElementRef;
    @ViewChild('filterlink') flink: ElementRef;
    public childItems: MenuItem[] | MenuItem[][];
    private $subscriptions: Subscription = new Subscription();
    private linkid: string;
    private itemClicked = false;
    public facilitytype = 'Navigation';

    // Pagination
    public searchText = '';
    public maxSize = 7;
    public directionLinks = true;
    public autoHide = false;
    public responsive = false;

    selectedSubscriptionID: number;
    availableSubscriptions: string;

    public config: PaginationInstance = {
        id: 'paginationId',
        itemsPerPage: 20,
        currentPage: 1
    };

    public labels: any = {
        previousLabel: 'Previous',
        nextLabel: 'Next',
        screenReaderPaginationLabel: 'Pagination',
        screenReaderPageLabel: 'page',
        screenReaderCurrentLabel: `You're on page`
    };

    public isItemSelected() {
        return this.itemClicked === true;
    }

    constructor(private router: Router,
        private route: ActivatedRoute,
        private menuService: MenuService,
        private logger: LoggingMessageService,
        private sessionService: SessionStorageService,
        private navigationService: UserNavigationService,
        private iframeService: IframeService,
        private subscriptionService: SubscriptionChangeService) {

        const menuSubscription = this.router.events
            .subscribe((e: any) => {
                // If it is a NavigationEnd event display the report
                if (e instanceof NavigationEnd) {
                    if (e && e.url && e.url.includes('menuextension')) {
                        this.handleMenuExtensionNavigationEvent(e);
                    }
                }
            });
        this.$subscriptions.add(menuSubscription);
    }

    ngOnInit() {
        this.selectedSubscriptionID =  this.subscriptionService.SelectedSubscription;;
        this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
        this.iframeService.setLinkId('');
    }

    private updateLinkId() {
        const linkId = this.route.snapshot.queryParams.linkid;
        if (linkId) {
            this.linkid = linkId;
        }
    }

    private handleMenuExtensionNavigationEvent(e: NavigationEnd) {
        this.updateLinkId();
        this.itemClicked = false;
        this.config = {
            id: 'paginationId',
            itemsPerPage: 20,
            currentPage: 1
        };
        const isHospitalMenu = NavigationUtils.IsLastPartSubscriptionItemFromPermId(this.linkid);
        this.setFacilityType(isHospitalMenu);
        this.getMenuItems(isHospitalMenu);
        this.searchText = '';
        this.navigationService.emitNavigationComplete(this.linkid);
        this.logger.debug('menu-extension', 'handleMenuExtensionNavigationEvent', this.selectedSubscriptionID, this.availableSubscriptions, `Changing NavLink id: ${this.linkid}`, '');
    }

    private setFacilityType(isHospitalMenu: boolean) {
        this.facilitytype = (isHospitalMenu) ? 'Facilities' : 'Units';
    }

    private filterMenuItems(items: MenuItem[]): MenuItem[] {
        const filtered = new Array<MenuItem>();
        const filterKey = (this.facilitytype === 'Facilities') ? '_f' : '_u';

        if (items) {
            items.forEach(item => {
                if (item) {
                    const id = item.id.toString().toLowerCase();
                    if (id.includes(filterKey)) {
                        filtered.push(item);
                    }
                }
            });
        }
        return filtered;
    }

    private getMenuItems(isHospitalMenu: boolean) {
        const subId = NavigationUtils.GetSubscriptionIdFromPermId(this.linkid);
        const hospparts = this.linkid.split("_u");
        const hospMenuItemsMap = this.navigationService.HospitalMenuItemCache;
        const unitMenuItemsMap = this.navigationService.UnitMenuItemCache;
        const stubbedItems = (isHospitalMenu) ? hospMenuItemsMap.get(subId) : unitMenuItemsMap.get(hospparts[0]);
        const items = this.filterMenuItems(stubbedItems);
        this.childItems = items;
    }

    onMenuExtensionClicked(item, $event) {
        if (this.itemClicked === false) {
            const selectedItem = item as MenuItem;
            this.setSelectedItemInSession(selectedItem);
            selectedItem.command({ item: selectedItem, originalEvent: $event });
            this.itemClicked = true;
            this.menuService.menu.effectDuration = 0;
        }

        this.disposeAll();
    }

    private setSelectedItemInSession(selectedItem: MenuItem) {
        if(this.facilitytype === 'Facilities') {
            this.sessionService.setUserHospitalName(selectedItem.label);
        } else {
            this.sessionService.setUserUnitName(selectedItem.label);
        }
    }

    onMouseOver(item) {
        window.parent.postMessage('showdemographics:' + item.id, '*');
    }

    onMouseLeave(item) {
        window.parent.postMessage('hidedemographics:' + item.id, '*');
    }

    // Pagination
    onPageChange(page: number) {
        this.config.currentPage = page;
    }

    onPageBoundsCorrection(page: number) {
        this.config.currentPage = page;
    }

    private disposeAll() {
        if (this.flink && this.flink.nativeElement && this.flink.nativeElement.parentElement) {
            this.flink.nativeElement.parentElement.removeChild(this.flink.nativeElement);
        }

        this.childItems = null;
        this.pagin = null;
        this.flink = null;
        this.config = null;
    }

    private Unsubscribe() {
        this.disposeAll();
        if (this.$subscriptions) {
            this.$subscriptions.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.Unsubscribe();
    }
}
